<template>
  <b-modal :active="show" @close="requestClose" :width="620">
    <div class="modal-card" style="padding-bottom:3rem">
      <div class="modal-card-head">
        <div class="modal-card-title">Promotioncode anlegen</div>
      </div>
      <div class="modal-card-body" style="overflow-y:scroll !important;">
        <section>
          <b-field label="Name" horizontal>
            <b-input
              v-model="reduction.name"
              required
              lazy
              @input="validateCode"
              placeholder="Name der Promotion"
            ></b-input>
          </b-field>
          <b-field label="Code" :message="codeMessage" horizontal>
            <b-input
              v-model="reduction.code"
              :lazy="true"
              @input="validateCode"
              required
              placeholder="Promotioncode"
            ></b-input>
          </b-field>
          <hr />
          <b-field horizontal>
            <div class="field">
              <b-checkbox v-model="reduction.isUnique" required
                >Einmalig auf eine Bestellung einlösbar</b-checkbox
              >
            </div>
          </b-field>
          <b-field label="Gültig von" horizontal>
            <b-datetimepicker
              placeholder="Gültigkeit wählen"
              required
              v-model="reduction.begin"
              :max-datetime="reduction.end"
              horizontal-time-picker
            ></b-datetimepicker>
          </b-field>

          <b-field label="Gültig bis" horizontal>
            <b-datetimepicker
              placeholder="Gültigkeit wählen"
              required
              v-model="reduction.end"
              :min-datetime="reduction.begin"
              horizontal-time-picker
            ></b-datetimepicker>
          </b-field>

          <div v-if="type === 'p'">
            <b-field label="Prozent" horizontal>
              <b-numberinput
                type="is-light"
                v-model="reduction.percentage"
                min="1"
                max="99"
              ></b-numberinput>
            </b-field>
          </div>
          <div>
            <b-field v-if="type === 'f'" label="Betrag in €" horizontal>
              <b-input
                type="number"
                icon="euro-sign"
                v-model="reduction.amount"
                min="1"
              ></b-input>
              <!-- <b-numberinput
                type="is-light"
                v-model="reduction.amount"
                min="1"
              ></b-numberinput>               -->
            </b-field>
          </div>
          <hr />
          <div>
            <b-button
              type="is-dark"
              @click="addConstraint"
              icon-left="plus-circle"
              >Einschränkung hinzufügen</b-button
            >

            <b-notification
              class="u-mt1 "
              :closable="false"
              v-if="reduction && reduction.constraints.length == 0"
            >
              <p class="has-text-centered has-text-weight-bold">
                Keine Einschränkungen
              </p>
            </b-notification>

            <div v-if="reduction" class="u-mt2">
              <div v-for="(r, i) in reduction.constraints" :key="i">
                <p v-if="i > 0" class="u-mt1 u-mb1 has-text-weight-bold">
                  und
                </p>

                <b-tag type="is-danger" v-if="!r.value || r.value.length == 0"
                  >Unvollständig!</b-tag
                >

                <div class="box ">
                  <div class="columns is-variable is-1">
                    <b-field class="column is-marginless">
                      <b-select v-model="r.field" expanded>
                        <option :value="0">Promotion</option>
                        <option :value="1">Hotel in Land</option>
                        <option :value="2">Thema</option>
                        <option :value="3">Mandant</option>
                        <option :value="4">Angebot</option>>
                      </b-select>
                    </b-field>
                    <b-field class="column is-marginless">
                      <b-select v-model="r.comparer" expanded>
                        <option :value="0">Gleich</option>
                        <option :value="1">Nicht gleich</option>
                      </b-select>
                    </b-field>
                    <b-field class="column is-marginless">
                      <b-select v-if="r.field != 4" v-model="r.value" expanded>
                        <option
                          v-for="k in comboValues[r.field]"
                          :key="k.key"
                          :value="k.key"
                          >{{ k.value }}</option
                        >
                      </b-select>
                      <div v-if="r.field == 4" expanded>
                        <OfferSelection @selected="o => selectedOffer(o, r)" />
                      </div>
                    </b-field>
                    <div class="column is-marginless">
                      <b-button type="is-text" @click="removeConstraint(i)"
                        >Entfernen</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <footer class="modal-card-foot">
        <b-button type="is-text" @click="cancel" expanded>Abbrechen</b-button>
        <b-button
          type="is-primary"
          :disabled="!valid"
          @click="saveReduction"
          expanded
          >Speichern</b-button
        >
      </footer>
    </div>
    <b-loading
      :is-full-page="false"
      :active.sync="loading"
      :can-cancel="false"
    ></b-loading>
  </b-modal>
</template>

<script>
import reductionApi from '@/api/reduction-api'
import offerApi from '@/api/offers-api'
import OfferSelection from '@/components/OfferSelection'
export default {
  name: 'CreateReductionModal',
  props: {
    type: String,
    show: Boolean,
  },
  components: {OfferSelection},
  data() {
    return {
      reduction: {
        name: '',
        code: '',
        begin: null,
        end: null,
        percentage: 1,
        amount: 1,
        constraints: [],
      },
      comboValues: [],
      loading: false,
      codeMessage: '',
      valid: false,
    }
  },
  async mounted() {
    //     <option :value="0">Promotion</option>
    // <option :value="1">Hotel in Land</option>
    // <option :value="2">Thema</option>
    // <option :value="3">Mandant</option>
    // <option :value="4">Angebot</option>>
    this.comboValues.push(await offerApi.getPromotions())
    this.comboValues.push(await offerApi.getCountries())
    this.comboValues.push(await offerApi.getThemes())
    this.comboValues.push([
      {
        key: '1',
        value: 'SST',
      },
      {
        key: '4',
        value: 'BestCase',
      },
      {
        key: '32',
        value: 'hoxami',
      },
    ])
  },
  methods: {
    async saveReduction() {
      if (
        this.reduction.code &&
        this.reduction.name &&
        this.reduction.begin != null &&
        this.reduction.end != null &&
        this.reduction.begin.getTime() != this.reduction.end.getTime()
      ) {
        const tz = d => {
          var date = new Date() // Or the date you'd like converted.
          return new Date(d.getTime() - date.getTimezoneOffset() * 60000)
            .toISOString()
            .replace(/T/, ' ')
            .replace(/\..+/, '')
        }
        let dto = {
          name: this.reduction.name,
          code: this.reduction.code,
          validFrom: tz(this.reduction.begin),
          validTo: tz(this.reduction.end),
          isUnique: this.reduction.isUnique,
        }
        // const tzOffset = new Date().getTimezoneOffset() * -1;
        // dto.validFrom.setMinutes(dto.validFrom.getMinutes() + tzOffset)
        // dto.validTo.setMinutes(dto.validTo.getMinutes() + tzOffset)

        if (this.reduction.constraints.length > 0) {
          dto.constraints = this.reduction.constraints
        }
        this.loading = true
        if (this.type === 'p') {
          dto.percentage = this.reduction.percentage / 100
          let res = await reductionApi.createPercentageReduction(dto)
          this.$buefy.toast.open('Angelegt')
          this.$emit('close', res)
        }
        if (this.type === 'f') {
          ;(dto.currency = 'EUR'), (dto.amount = this.reduction.amount)
          let res = await reductionApi.createFixedReduction(dto)
          this.$buefy.toast.open('Angelegt')
          this.$emit('close', res)
        }
        this.loading = false
      } else {
        this.$buefy.toast.open('Bitte prüfen Sie Ihre Eingaben!')
      }
    },
    cancel() {
      this.$emit('close')
    },
    requestClose() {
      this.$emit('close')
    },
    selectedOffer(offer, constraint) {
      if (offer) {
        constraint.value = offer.id
      } else {
        constraint.value = ''
      }
    },
    addConstraint() {
      this.reduction.constraints.push({
        field: 1,
        comparer: 0,
        value: '',
      })
    },
    removeConstraint(i) {
      this.reduction.constraints.splice(i, 1)
    },
    async validateCode() {
      if (this.reduction.code) {
        const res = await reductionApi.getReductions(
          1,
          1,
          'ValidFrom',
          null,
          this.reduction.code,
        )
        if (res.total !== 0) {
          this.codeMessage = 'Dieser Code existiert bereits.'
          this.valid = false
        } else {
          this.codeMessage = ''
          this.valid = this.reduction.name.length > 0
        }
      } else {
        this.valid = false
        this.codeMessage = ''
      }
    },
  },
}
</script>

<style lang="scss">
.modal-content {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.modal-card,
.modal-content {
  width: auto;
}

.modal,
.modal-card,
.modal-card-body,
.modal-content {
  overflow: visible !important; //to show datepicker on desktop
}
</style>
